import React from "react";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import styles from "@/styles/contact.module.scss";
import Form from "@/src/components/Shared/Form";
import { ContactsElements } from "@/src/components/Layout/Footer";
import server from "@/src/api/server";
import Seo from "@/src/components/Shared/Next-seo";
import BreadCrumb from "@/src/components/Shared/BreadCrumbs";
import ContactNumbers from "@/src/components/Home/ContactNumbers";
import { checkRedirect } from "@/src/components/helpers/functions";
const ContactPage = ({ contactData, initData, error, seoData }) => {
  const { locale, formatMessage } = useIntl();
  error && console.log(JSON.parse(error));
  return (
    <>
      {seoData?.title?.[locale] && (
        <Seo
          title={seoData?.title?.[locale]}
          description={seoData?.description?.[locale]}
          keywords={seoData?.keywords?.[locale]}
        />
      )}
      <div className={`contact-page ${styles.contact}`}>
        <BreadCrumb
          heading={formatMessage({ id: "contact-us" })}
          description={`${formatMessage({
            id: "main",
          })} / ${formatMessage({
            id: "contact-us",
          })}`}
          background={contactData?.breadCurmbImage}
        />

        <Row>
          <h2 className="contact-header unique-bold">
            <FormattedMessage id="communicate" />
          </h2>
        </Row>
        <div className="contact-page-top wrapper">
          <Row>
            <div className="contact-row-wrapper p-0">
              <Row className="contact-row">
                <Col xs="12" md="6" className="align-self-center">
                  <Form
                    formTitle={<FormattedMessage id="service_question" />}
                    formSubtitle={<FormattedMessage id="service_ask" />}
                  />
                </Col>

                <Col xs="12" md="6">
                  <div
                    className="contact-page-map"
                    data-aos="fade-up"
                    data-aos-duration="300"
                    data-aos-delay="400"
                    dangerouslySetInnerHTML={{
                      __html: initData?.siteInfo?.mapframe ?? "",
                    }}
                  ></div>
                </Col>
              </Row>
            </div>
          </Row>
        </div>
        <ContactNumbers initData={initData} />
        <Row className="contact-info">
          <ContactsElements initdata={initData} locale={locale} />
        </Row>
      </div>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  const [homeResponse, seoPageResponse] = await Promise.all([
    server.get("/pages/home"),
    server.get("/pages/seo-data"),
  ]);

  const sectionData = (r) => r?.data?.data?.page?.sections || [];
  const homeData = (section) =>
    sectionData(homeResponse)?.filter((e) => e?.slug == section)?.[0] || [];
  const seoData = sectionData(seoPageResponse)?.find(
    (section) => section?.pageName === "contact-us"
  );
  return {
    props: {
      contactData: {
        breadCurmbImage: homeData("intro")?.items[0]?.backgroundImage,
      },
      seoData,
    },
  };
}

export default ContactPage;
